export default function ProductPrice(props: { price: number; unit?: string }) {
  return (
    <div className="flex flex-row items-center justify-center w-full gap-x-2">
      <span>{(props.price / 100).toFixed(2).replace(".", ",")} Kč</span>
      <span>/</span>
      <span>{props.unit || "ks"}</span>
    </div>
  )
}
